/* Aikas Art: Zuschnitt-Positionen (Zuschnitt Laenge / Zuschnitt Breite) im Warenkorb immer passend zu den Regalen halten.
   - Anzahl Zuschnitt = Anzahl Regale mit Wunschlaenge bzw. Wunschbreite (inkl. Menge).
   - Wird ein Regal geloescht, verschwindet der Zuschnitt mit; wird ein Zuschnitt geloescht, kommt er wieder.
   - Mengen-/Loeschen-Buttons der Zuschnitt-Zeilen werden ausgeblendet.
   Ausserdem: "Hinzufuegen"-Button des Holzpflegewachs-Angebots im Warenkorb (snippets/aikas-wax-cart-upsell.liquid). */
(function () {
  if (window.__aikasCartSync) return;
  window.__aikasCartSync = true;
  var H = { len: 'zuschnitt-laenge', width: 'zuschnitt-breite' };
  var P = { len: 'Individuelle Länge', width: 'Individuelle Breite' };
  var busy = false, again = false, subscribed = false;

  var css = document.createElement('style');
  css.textContent =
    '.cart-item:has(a[href*="/products/zuschnitt-"]) .cart-item__quantity-wrapper,' +
    '.cart-item:has(a[href*="/products/zuschnitt-"]) quantity-popover,' +
    '.cart-item:has(a[href*="/products/zuschnitt-"]) cart-remove-button,' +
    '.cart-item:has(a[href*="/products/zuschnitt-"]) .cart-item__quantity .quantity { display: none !important; }' +
    '.cart-item:has(a[href*="/products/zuschnitt-"]) .cart-item__image-container { opacity: .6; }';
  document.head.appendChild(css);

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function post(url, body) {
    return fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var need = { len: 0, width: 0 }, have = { len: { q: 0, key: null }, width: { q: 0, key: null } };
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p[P.len]) need.len += it.quantity;
          if (p[P.width]) need.width += it.quantity;
          if (it.handle === H.len) { have.len.q += it.quantity; have.len.key = it.key; }
          if (it.handle === H.width) { have.width.q += it.quantity; have.width.key = it.key; }
        });
        var updates = {}, adds = [];
        ['len', 'width'].forEach(function (k) {
          if (have[k].q === need[k]) return;
          if (have[k].key) updates[have[k].key] = need[k];
          else if (need[k] > 0) adds.push(k);
        });
        if (!Object.keys(updates).length && !adds.length) return false;
        var chain = Promise.resolve();
        if (Object.keys(updates).length) chain = chain.then(function () { return post('cart/update.js', { updates: updates }); });
        adds.forEach(function (k) {
          chain = chain.then(function () {
            return fetch(root() + 'products/' + H[k] + '.js').then(function (r) { return r.json(); }).then(function (prod) {
              return post('cart/add.js', { items: [{ id: prod.variants[0].id, quantity: need[k] }] });
            });
          });
        });
        return chain.then(function () { return true; });
      })
      .then(function (changed) { if (changed) return refresh(); })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; sync(); } });
  }

  function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var d = document.querySelector('cart-drawer');
    if (!d || typeof d.getSectionsToRender !== 'function' || typeof d.getSectionInnerHTML !== 'function') return;
    var secs = d.getSectionsToRender();
    return fetch(root() + '?sections=' + secs.map(function (s) { return s.id; }).join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        secs.forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el && data[s.id]) el.innerHTML = d.getSectionInnerHTML(data[s.id], s.selector);
        });
      });
  }

  /* Holzpflegewachs-Set aus dem Warenkorb heraus hinzufuegen (Button wird per Section-Rendering eingesetzt,
     deshalb hier zentral per Event-Delegation statt mit Skript im Snippet) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aikas-up-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    post('cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-aikas-up-add'), 10), quantity: 1 }] })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return refresh(); })
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aikas-wax-upsell' });
      })
      .catch(function () { b.disabled = false; });
  });

  function trySubscribe() {
    if (subscribed) return true;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 300); });
      subscribed = true;
    }
    return subscribed;
  }
  /* Fallback, falls ein Theme-Skript den Warenkorb ohne Event aendert: Warenkorb-Requests mitlesen */
  if (window.fetch && !window.__aikasFetchWrapped) {
    window.__aikasFetchWrapped = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/(change|update|add|clear)/.test(url) && !(init && init.__aikas)) {
        p.then(function () { if (!busy) setTimeout(sync, 400); }).catch(function () {});
      }
      return p;
    };
  }
  function start() {
    trySubscribe();
    sync();
  }
  window.addEventListener('load', start);
})();
